import { render, staticRenderFns } from "./PageWineApprovedForm.vue?vue&type=template&id=1d57e143"
import script from "./PageWineApprovedForm.vue?vue&type=script&lang=ts"
export * from "./PageWineApprovedForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports